{
  "program": [
    {
      "programTypeGuid": "D972DA85-0565-4971-B031-FC44878C6EA9",
      "element": [
        {
          "id": "engagementRegistrationId",
          "displayName": "Event ID"
        },
        {
          "id": "engagementName",
          "displayName": "Event Name"
        },
        {
          "id": "engagementSubType",
          "displayName": "Event Type"
        },
        {
          "id": "payoutMetric",
          "displayName": "Payment Type"
        }
      ],
      "hiddenElements": [
        { "name": "programType" },
        { "name": "payeeID" },
        { "name": "m2CategoryTypeValue" }
      ]
    },
    {
      "programTypeGuid": "C5D3A897-C737-4EEC-BFC7-D9FF1FB7F315",
      "element": [
        {
          "id": "engagementRegistrationId",
          "displayName": "Engagement ID"
        },
        {
          "id": "engagementName",
          "displayName": "Engagement Name"
        },
        {
          "id": "engagementSubType",
          "displayName": "Sub Type"
        },
        {
          "id": "payoutMetric",
          "displayName": "Payout Metric"
        }
      ],
      "hiddenElements": [
        { "name": "customerTenantId" },
        { "name": "tier" },
        { "name": "maturityStatus" },
        { "name": "maturityDate" },
        { "name": "fundingAmount" },
        { "name": "amount" },
        { "name": "paymentDocumentNumber" }
      ]
    }
  ]
}
